// BarberHome.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const BarberHome = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-zinc-950 p-6">
      <h1 className="text-3xl font-bold mb-8 text-cyan-50">Barber Dashboard</h1>
      <div className="grid gap-4 w-full max-w-sm">
        <button
          onClick={() => navigate("/barber-breaks")}
          className="w-full p-4 bg-zinc-800 text-white rounded-2xl shadow hover:bg-zinc-700 transition"
        >
          Pauze i radno vreme
        </button>
        <button
          onClick={() => navigate("/barber-appointments")}
          className="w-full p-4 bg-zinc-800 text-white rounded-2xl shadow hover:bg-zinc-700 transition"
        >
          Pogledaj termine
        </button>
        <button
          onClick={() => navigate("/barber-create-appointment")}
          className="w-full p-4 bg-zinc-800 text-white rounded-2xl shadow hover:bg-zinc-700 transition"
        >
          Kreiraj termin
        </button>
        <button
          onClick={() => navigate("/barber-settings")}
          className="w-full p-4 bg-zinc-800 text-white rounded-2xl shadow hover:bg-zinc-700 transition"
        >
          Dostupnost i VIP dodela
        </button>
      </div>
    </div>
  );
};

export default BarberHome;
